import { render, staticRenderFns } from "./DirectSettlement.vue?vue&type=template&id=3d2c223b"
import script from "./DirectSettlement.vue?vue&type=script&lang=js"
export * from "./DirectSettlement.vue?vue&type=script&lang=js"
import style0 from "./DirectSettlement.vue?vue&type=style&index=0&id=3d2c223b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports